import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

const Specialists = ({ img, name, designation, authorLink }) => {
  return (
    <>
      <div className="st-member st-style1 st-zoom">
        <div className="st-member-img">
          <img src={img} alt={img} className="st-zoom-in" />
        </div>
        <div className="st-member-meta">
          <div className="st-member-meta-in">
            <h3 className="st-member-name">{name}</h3>
            <div className="st-member-designation">{designation}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specialists;
